import * as React from 'react'
import { useContext } from "react"
import { AppContext } from "./appcontext"
import { Routes, Route, useNavigate } from "react-router-dom"
//import "../styles/main.css"
import { Blog } from "./blog"
import { Instructions } from "./instructions"
import { Stripes } from './stripes'

export function Home(props: {}) {

    return <React.Fragment>
        <Routes>
            <Route path="/blog" element={ <Blog />} />
            <Route path="/*" element={ <Instructions />} />
        </Routes>
    </React.Fragment>
}


